
import { NgModule } from "@angular/core";
import { HttpClientModule} from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { CommonModule } from '@angular/common';

import { MatToolbarModule } from "@angular/material/toolbar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MAT_DATE_LOCALE, MatRippleModule, MatNativeDateModule, MAT_DATE_FORMATS} from '@angular/material/core';
import { MatTableModule} from '@angular/material/table';
import { MatButtonToggleModule} from '@angular/material/button-toggle';
import { MatChipsModule} from '@angular/material/chips';
import { MatIconModule} from '@angular/material/icon';
import { MatInputModule} from '@angular/material/input';
import { MatSelectModule} from '@angular/material/select';
import { MatDialogModule} from '@angular/material/dialog';
import { MatDividerModule} from '@angular/material/divider';
import { MatMenuModule} from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSortModule } from "@angular/material/sort";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSliderModule } from '@angular/material/slider';

import { NotFoundComponent } from './components/not-found/not-found.component';
import { FlatMessageComponent } from './components/flat-message/flat-message.component';
import { TopNavbarComponent } from "./components/top-navbar/top-navbar.component";
import { TopNavbarTabComponent } from "./components/top-navbar/components/top-navbar-tab/top-navbar-tab.component";
import { UserSidenavComponent } from './components/user-sidenav/user-sidenav.component';
import { ButtonModules } from './components/button-modules/button-modules.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { StatusToStringPipe } from "../pipes/status.pipe";
import { HistoricalComponentComponent } from "./components/historical-component/historical-component.component";
import { CardBorderComponent } from "./components/card-border/card-border.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { FullCalendarModule } from "@fullcalendar/angular";
import { HistoricalRequestComponent } from "./components/historical-request/historical-request.component";
import { PatientSidenavComponent } from "./components/patient-sidenav/patient-sidenav.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TooltipModule } from "../directives/tooltip/tooltip.module";
import { CardService } from "../services/ambulatory-care/card.service";
import { MatStepperModule } from "@angular/material/stepper";
import { CdkDrag, DragDropModule } from "@angular/cdk/drag-drop";
import { ExtractAgePipe } from "../pipes/age.pipe";
import { TriageService } from "../services/triage/triage.service";
import { ImageComponent } from "./components/image/image.component";
import { TypeTriageService } from "../services/triage/type-triage.service";
import { TranslatePipe } from "../pipes/translate.pipe";
import { ImageCropperComponent } from "ngx-image-cropper";
import { NgxMatDateAdapter, NgxMatDatetimePickerModule, NgxMatTimepickerModule } from "@angular-material-components/datetime-picker";
import { NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS, NgxMatMomentAdapter, NgxMatMomentModule } from "@angular-material-components/moment-adapter";
import { MAT_MOMENT_DATE_FORMATS } from "@angular/material-moment-adapter";
import { DateTimeComponent } from "./components/date-time/date-time.component";
import { CustomSnackbarComponent } from './components/snackbar/custom-snackbar/custom-snackbar.component';
import { LoginSessionLockComponent } from "../../public/login-session-lock/login-session-lock.component";
import { LookupValuePipe } from "../pipes/lookup-value.pipe";
import { DiagnosticMasterAutocompleteComponent } from "./components/components-master/diagnostic-master.autocomplete/diagnostic-master.autocomplete.component";
import { ProceduresMasterAutocompleteComponent } from "./components/components-master/procedures-master.autocomplete/procedures-master.autocomplete.component";
import { CluesAutocompleteComponent } from "./components/components-master/clues-master.autocomplete/clues.autocomplete.component";
import { NgxMatTimelineModule } from "ngx-mat-timeline";
import { VersionLabelComponent } from './components/version-label/version-label.component';
import { DialogAlertComponent } from "./components/dialog-alert/dialog-alert.component";
import { LoadingComponent } from "./components/loading/loading.component";
import { LoadingButtonComponent } from 'src/app/core/shared/components/loading-button/loading-button.component';
import { DialogCancelReasonComponent } from './components/dialog-cancel-reason/dialog-cancel-reason.component';

@NgModule({
    declarations: [
        FlatMessageComponent,
        TopNavbarComponent,
        TopNavbarTabComponent,
        UserSidenavComponent,
        ButtonModules,
        SnackbarComponent,
        HistoricalComponentComponent,
        HistoricalRequestComponent,
        CardBorderComponent,
        PatientSidenavComponent,
        DateTimeComponent,
        CustomSnackbarComponent,
        ProceduresMasterAutocompleteComponent,
        DiagnosticMasterAutocompleteComponent,
        CluesAutocompleteComponent,
        DialogAlertComponent,
        DialogCancelReasonComponent
    ],
    exports: [
        HttpClientModule,
        RouterModule,
        CommonModule,
        // components
        FlatMessageComponent,
        TopNavbarComponent,
        TopNavbarTabComponent,
        UserSidenavComponent,
        ButtonModules,
        SnackbarComponent,
        HistoricalComponentComponent,
        HistoricalRequestComponent,
        CardBorderComponent,
        PatientSidenavComponent,
        DateTimeComponent,
        // material
        MatToolbarModule,
        MatSidenavModule,
        MatCardModule,
        MatGridListModule,
        MatButtonModule,
        MatFormFieldModule,
        MatRippleModule,
        MatTableModule,
        MatPaginator,
        MatPaginatorModule,
        MatSortModule,
        MatButtonToggleModule,
        MatChipsModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatDividerModule,
        MatMenuModule,
        MatListModule,
        MatTabsModule,
        MatExpansionModule,
        MatCheckboxModule,
        MatSnackBarModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatSlideToggleModule,
        MatAutocompleteModule,
        MatTooltipModule,
        MatStepperModule,
        MatSliderModule,
        FullCalendarModule,
        FormsModule,
        StatusToStringPipe,
        ExtractAgePipe,
        TooltipModule,
        CdkDrag,
        DragDropModule,
        ImageCropperComponent,
        LookupValuePipe,
        NgxMatTimelineModule,
        ProceduresMasterAutocompleteComponent,
        DiagnosticMasterAutocompleteComponent,
        CluesAutocompleteComponent,
		VersionLabelComponent
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-mx' },
        {
            provide: NgxMatDateAdapter,
            useClass: NgxMatMomentAdapter,
            deps: [MAT_DATE_LOCALE, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        CardService, TriageService, TypeTriageService],
    imports: [
        MatDialogModule,
        RouterModule,
        HttpClientModule,
        CommonModule,
        // material
        MatToolbarModule,
        MatSidenavModule,
        MatCardModule,
        MatGridListModule,
        MatButtonModule,
        MatFormFieldModule,
        MatRippleModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatButtonToggleModule,
        MatChipsModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatDividerModule,
        MatMenuModule,
        MatBadgeModule,
        MatTabsModule,
        MatListModule,
        MatExpansionModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSnackBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatStepperModule,
        MatAutocompleteModule,
        MatSliderModule,
        FormsModule,
        StatusToStringPipe,
        ExtractAgePipe,
        FullCalendarModule,
        CdkDrag,
        DragDropModule,
        ImageComponent,
        TranslatePipe,
        ImageCropperComponent,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatMomentModule,
        ReactiveFormsModule,
        LoginSessionLockComponent,
        LookupValuePipe,
        NgxMatTimelineModule,
        VersionLabelComponent,
        LoadingComponent,
        NotFoundComponent,
        LoadingButtonComponent
    ]
})

export class SharedModule{}
